(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    (() => {
function init(root) {
 root.querySelectorAll('.nj-product-gallery').forEach(gallery => {
  if (gallery.dataset.ready) return;
  const track = gallery.querySelector('.nj-gallery-track');
  if (!track) return;
  gallery.dataset.ready = 'true';
  const slides = [...track.querySelectorAll('.nj-gallery-slide')];
  const dots = [...gallery.querySelectorAll('.nj-gallery-dot')];
  const dialog = gallery.querySelector('dialog');
  let active = 0, startX = 0, startY = 0, dragged = false, frame;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const go = index => track.scrollTo({left: slides[Math.max(0, Math.min(slides.length - 1, index))].offsetLeft - slides[0].offsetLeft, behavior: reduced.matches ? 'auto' : 'smooth'});
  function sync() {
   const base = slides[0].getBoundingClientRect().left;
   const left = track.getBoundingClientRect().left;
   active = slides.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? i : best, 0);
   dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === active)));
  }
  track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(sync); }, {passive:true});
  gallery.querySelectorAll('[data-index]').forEach(control => control.addEventListener('click', event => { event.preventDefault(); go(Number(control.dataset.index)); }));
  track.addEventListener('keydown', event => {
   let next;
   if(event.key === 'ArrowRight') next = active + 1;
   if(event.key === 'ArrowLeft') next = active - 1;
   if(event.key === 'Home') next = 0;
   if(event.key === 'End') next = slides.length - 1;
   if(next !== undefined) {event.preventDefault();go(next);}
  });
  track.addEventListener('pointerdown', event => {startX=event.clientX;startY=event.clientY;dragged=false;}, {passive:true});
  track.addEventListener('pointermove', event => {if(Math.abs(event.clientX-startX)>10 || Math.abs(event.clientY-startY)>10) dragged=true;}, {passive:true});
  track.addEventListener('pointercancel', () => {dragged=true;});
  slides.forEach(slide => {
   slide.addEventListener('dragstart', event => event.preventDefault());
   slide.addEventListener('click', event => {
    if(dragged && event.detail !== 0) {event.preventDefault();return;}
    if(!dialog || !dialog.showModal) return;
    event.preventDefault();
    const large = dialog.querySelector('img');
    large.src=slide.href;large.alt=slide.querySelector('img').alt;
    dialog.showModal();
   });
  });
  dialog.querySelector('button').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {if(event.target===dialog) {const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) dialog.close();}});
  new ResizeObserver(() => {track.scrollTo({left:slides[active].offsetLeft-slides[0].offsetLeft,behavior:'instant'});}).observe(track);
  sync();
 });
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document)); else init(document);
document.addEventListener('shopify:section:load',event=>init(event.target));
})();
  } catch(e) { console.error(e); }
})();
})();
